import { createReducer } from '@topconagriculture/frontend-utils';

import { addNote, createLot, deleteNote, editNote, getLotById, getLots, updateLot } from './lots.actions';
import { Lot } from './lots.types';

export type LotsState = Lot[];

const initialState: LotsState = [];

const lotsReducer = createReducer(initialState, {
  [getLots.done.type]: (_state: LotsState, action: ReturnType<typeof getLots.done>) => {
    return action.payload.result;
  },
  [getLotById.done.type]: (state: LotsState, action: ReturnType<typeof getLotById.done>) => {
    const recievedLot = action.payload.result;
    return state.map((lot) => (lot.id === recievedLot.id ? recievedLot : lot));
  },
  [createLot.done.type]: (state: LotsState, action: ReturnType<typeof createLot.done>) => {
    return [...state, action.payload.result];
  },
  [updateLot.done.type]: (state: LotsState, action: ReturnType<typeof updateLot.done>) => {
    const editedLot = action.payload.result;
    return state.map((lot) => (lot.id === editedLot.id ? editedLot : lot));
  },
  [addNote.done.type]: (state: LotsState, action: ReturnType<typeof addNote.done>) =>
    state.map((x) =>
      x.id === action.payload.params.data.lotId
        ? {
            ...x,
            notes: x.notes ? [...x.notes, action.payload.result] : [action.payload.result],
          }
        : x,
    ),
  [deleteNote.done.type]: (state: LotsState, action: ReturnType<typeof deleteNote.done>) =>
    state.map((x) =>
      x.id === action.payload.params.data.lotId
        ? {
            ...x,
            notes: x.notes && x.notes.filter((n) => n.id !== action.payload.params.data.id),
          }
        : x,
    ),
  [editNote.done.type]: (state: LotsState, action: ReturnType<typeof editNote.done>) =>
    state.map((x) =>
      x.id === action.payload.params.data.lotId
        ? {
            ...x,
            notes: x.notes && x.notes.map((n) => (n.id === action.payload.result.id ? action.payload.result : n)),
          }
        : x,
    ),
});

export default lotsReducer;
